var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from "react";

var SvgLegendGarage = function SvgLegendGarage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef
  }, _extends({
    width: "1em",
    height: "1em"
  }, props)), React.createElement("title", null, title), React.createElement("defs", null, React.createElement("path", {
    id: "LegendGarage_svg__a",
    d: "M1041.958 370c-.758 0-1.48-.33-2.049-.953l-4.405-4.734c-.529-.587-1.295-.817-2.222-.673-2.333.447-4.61-.236-6.253-1.878a6.924 6.924 0 0 1-1.729-6.916l.287-.946 3.75 3.67c.427.451.997.7 1.604.7a2.19 2.19 0 0 0 1.604-.7l.025-.025c.451-.426.7-.996.7-1.603 0-.608-.249-1.178-.7-1.604l-.017-.017-3.653-3.734.946-.287a6.924 6.924 0 0 1 6.916 1.73c1.67 1.67 2.388 4.128 1.872 6.413l-.005.022c-.206.77-.01 1.397.615 1.97l4.806 4.477c.8.732 1.115 1.719.866 2.708-.276 1.097-1.2 2.02-2.296 2.296a2.705 2.705 0 0 1-.662.084"
  })), React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#LegendGarage_svg__a",
    transform: "translate(-1025 -350)"
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLegendGarage, _extends({
    svgRef: ref
  }, props));
});
export default ForwardRef;